import { SortDir } from '../../models/billingHistory/billingHistory';

export const defaultSortingParams = {
  sortBy: 'issueDate',
  sortDirection: 'desc' as SortDir,
};
